"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transporter = void 0;
// abstract class of transporter to be extended with implementations
var Transporter = /** @class */ (function () {
    function Transporter() {
    }
    return Transporter;
}());
exports.Transporter = Transporter;
//# sourceMappingURL=transporter.js.map